// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3KEEb","title":"styles_title__3ttdc"};